import React from 'react';
import { Route } from 'react-router-dom';

import ReviewList from '../../domain/Review/List/ReviewList';
import ReviewDetailPage from '../../pages/ReviewDetailPage';
import ReviewWriteContainer from '../../containers/review/ReviewWriteContainer';
import ReviewRewriteContainer from '../../containers/review/ReviewRewriteContainer';
import { AuthRoute } from './Routes';
import * as PATH from './path';

const ReviewRoute = () => {
  return (
    <>
      <Route exact path={PATH.REVIEW} component={ReviewList} />
      <Route
        exact
        path={`${PATH.REVIEW_DETAIL}/:id`}
        render={({ match }) => <ReviewDetailPage id={match.params.id} />}
      />
      <AuthRoute
        exact
        path={`${PATH.REVIEW_WRITE}/:type/:id`}
        component={ReviewWriteContainer}
      />
      <AuthRoute
        exact
        path={`${PATH.REVIEW_REWRITE}/:id`}
        component={ReviewRewriteContainer}
      />
    </>
  );
};

export default ReviewRoute;
